(function () {
  'use strict';

  const SHOPIFY_LIMIT = 12;

  function escapeHtml(str) {
    if (!str) return '';

    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function normalizeUrl(url) {
    if (!url) return '';

    if (url.startsWith('//')) {
      return 'https:' + url;
    }

    return url;
  }

  function getProductImage(product) {
    if (!product) return '';

    if (typeof product.featured_image === 'string') {
      return normalizeUrl(product.featured_image);
    }

    if (product.featured_image?.src) {
      return normalizeUrl(product.featured_image.src);
    }

    const image = product.images?.[0];

    if (typeof image === 'string') {
      return normalizeUrl(image);
    }

    if (image?.src) {
      return normalizeUrl(image.src);
    }

    return '';
  }

  function formatPrice(price) {
    const value = parseFloat(price || 0);

    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(value);
  }

  async function fetchCollection(handle) {
    const response = await fetch(
      `/collections/${handle}/products.json?limit=${SHOPIFY_LIMIT}`
    );

    if (!response.ok) {
      throw new Error(response.status);
    }

    const data = await response.json();

    return data.products || [];
  }

  function renderProduct(product) {
    const image = getProductImage(product);

    return `
      <a
        class="jdl-module__product"
        href="/products/${product.handle}"
      >
        ${
          image
            ? `
            <img
              class="jdl-module__product-img"
              src="${image}"
              alt="${escapeHtml(product.title)}"
              loading="lazy"
              onerror="this.style.display='none'"
            >
          `
            : `
            <div class="jdl-module__product-placeholder"></div>
          `
        }

        <div class="jdl-module__product-info">
          <span class="jdl-module__product-title">
            ${escapeHtml(product.title)}
          </span>

          <span class="jdl-module__product-price">
            ${formatPrice(product.variants?.[0]?.price)}
          </span>
        </div>
      </a>
    `;
  }

  function renderModule(module, products) {
    const handle = module.dataset.collection;

    module.innerHTML = `
      <div class="jdl-module__content">

        ${
          module.dataset.date
            ? `
            <div class="jdl-module__date">
              ${escapeHtml(module.dataset.date)}
            </div>
          `
            : ''
        }

        <h2 class="jdl-module__title">
          ${escapeHtml(module.dataset.title)}
        </h2>

        <p class="jdl-module__subtitle">
          ${escapeHtml(module.dataset.subtitle)}
        </p>

        <a
          class="jdl-module__cta"
          href="/collections/${handle}"
        >
          ${escapeHtml(module.dataset.cta || 'Voir la collection')}
        </a>

      </div>

      <div class="jdl-module__carousel">

        <button
          class="jdl-module__nav"
          data-dir="prev"
        >
          ‹
        </button>

        <div class="jdl-module__track">
          ${products.map(renderProduct).join('')}
        </div>

        <button
          class="jdl-module__nav"
          data-dir="next"
        >
          ›
        </button>

      </div>
    `;

    initSlider(module);
  }

  function initSlider(module) {
    const track = module.querySelector('.jdl-module__track');

    const prev = module.querySelector('[data-dir="prev"]');
    const next = module.querySelector('[data-dir="next"]');

    if (!track) return;

    function slide(direction) {
      const card = track.querySelector('.jdl-module__product');

      if (!card) return;

      const gap = 24;

      track.scrollBy({
        left: direction * (card.offsetWidth + gap),
        behavior: 'smooth'
      });
    }

    prev?.addEventListener('click', () => slide(-1));
    next?.addEventListener('click', () => slide(1));
  }

  async function hydrateModule(module) {
    const handle = module.dataset.collection;

    if (!handle) return;

    module.innerHTML = 'Chargement...';

    try {
      const products = await fetchCollection(handle);

      renderModule(module, products);
    } catch (error) {
      console.error(error);

      module.innerHTML =
        '<p>Impossible de charger cette collection.</p>';
    }
  }

  function init() {
    document
      .querySelectorAll('.jdl-module[data-collection]')
      .forEach(hydrateModule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();